import React from 'react';
import OutlinedInput from '@material-ui/core/OutlinedInput';

function OutlineTextField(props) {
    return (
        <OutlinedInput
            margin="none"
            variant="outlined"
            color="secondary"
            labelWidth={0}
            onChange={props.onChange}
            onBlur={props.onChange}
            inputProps={{
                ...props.inputProps
            }}            
            {...props}
        />
    ); 
}

export default OutlineTextField;